import clsx from 'clsx';
import React from 'react';

import { Icon } from '../Icon/Icon';

import styles from './ConfidencePill.module.scss';

type ConfidencePillLevel = 'high' | 'medium' | 'low' | 'edited';

interface ConfidencePillProps {
  level: ConfidencePillLevel;
  className?: string;
}

const LEVEL_LABEL: Record<ConfidencePillLevel, string> = {
  high: 'High confidence',
  medium: 'Medium confidence',
  low: 'Low confidence',
  edited: 'Edited by you',
};

const LEVEL_ICON: Record<ConfidencePillLevel, React.ReactNode> = {
  high: <Icon name="check" />,
  medium: <Icon name="exclamation-triangle" />,
  low: <Icon name="info" />,
  edited: <Icon name="edit" />,
};

export const ConfidencePill: React.FC<ConfidencePillProps> = ({ level, className }) => (
  <span className={clsx(styles.pill, styles[level], className)}>
    {LEVEL_ICON[level]}
    <span>{LEVEL_LABEL[level]}</span>
  </span>
);
